<template>
  <div class="left" :class="isMain ? 'not-right' : ''">
    <div class="logo">
      <div v-if="!playAlarmError">
        <h1><a @click="goMenu('Home')">The Cella<img src="" alt=""></a></h1>
      </div>
      <div v-else class="error">
        <h1><a @click="goMenu('Home')">클릭해 주세요<img src="" alt=""></a></h1>
      </div>
    </div>
    <div v-if="!isMain" class="menu-box">
      <div v-if="managerOrAdminOrBizAdmin" class="menu-1 menu" :class="menuInfo.mainTitle === 'Account' ? 'menu-select' : ''">
        <a @click="goMenu('Account')" class="menu-tlt">
          <span class="menu-img center-left"><img :src="menuInfo.mainTitle === 'Account' ? '/static/img/ico-menu-1-blue@2x.png' : '/static/img/ico-menu-1@2x.png'" alt=""></span>
          <span class="menu-txt center-left">계정/권한 관리</span>
          <span class="menu-img center-right"><img src="/static/img/ico-arrow-line-M@2x.png" alt=""></span>
        </a>
      </div>
      <div v-if="csOrAdminOrMonitor" class="menu-7 menu" :class="menuInfo.mainTitle === 'IncompletedPay' ? 'menu-select' : ''">
        <a @click="goMenu('IncompletedPay')" class="menu-tlt">
          <span class="menu-img center-left"><img :src="menuInfo.mainTitle === 'IncompletedPay' ? '/static/img/ico-menu-7-blue@2x.png' : '/static/img/ico-menu-7@2x.png'" alt=""></span>
          <span class="menu-txt center-left">불완전 모니터링</span>
          <span class="menu-img center-right"><img src="/static/img/ico-arrow-line-M@2x.png" alt=""></span>
        </a>
      </div>
      <div v-if="csOrAdmin" class="menu-2 menu"  :class="menuInfo.mainTitle === 'Customer' ? 'menu-select' : ''">
        <a @click="goMenu('Customer')" class="menu-tlt">
          <span class="menu-img center-left"><img :src="menuInfo.mainTitle === 'Customer' ? '/static/img/ico-menu-2-blue@2x.png' : '/static/img/ico-menu-2@2x.png'" alt=""></span>
          <span class="menu-txt center-left">고객 CS 응대</span>
          <span class="menu-img center-right"><img src="/static/img/ico-arrow-line-M@2x.png" alt=""></span>
        </a>
      </div>
      <div v-if="csOrAdmin" class="menu-3 menu" :class="menuInfo.mainTitle === 'Refund' ? 'menu-select' : ''">
        <a @click="goMenu('Refund')" class="menu-tlt">
          <span class="menu-img center-left"><img :src="menuInfo.mainTitle === 'Refund' ? '/static/img/ico-menu-3-blue@2x.png' : '/static/img/ico-menu-3@2x.png'" alt=""></span>
          <span class="menu-txt center-left">고객 입금 관리</span>
          <span class="menu-img center-right"><img src="/static/img/ico-arrow-line-M@2x.png" alt=""></span>
        </a>
      </div>
      <div v-if="csOrAdmin" class="menu-5 menu" :class="menuInfo.mainTitle === 'Nonpayment' ? 'menu-select' : ''">
        <a @click="goMenu('Nonpayment')" class="menu-tlt">
          <span class="menu-img center-left"><img :src="menuInfo.mainTitle === 'Nonpayment' ? '/static/img/ico-menu-5-blue@2x.png' : '/static/img/ico-menu-5@2x.png'" alt=""></span>
          <span class="menu-txt center-left">미결제 손실</span>
          <span class="menu-img center-right"><img src="/static/img/ico-arrow-line-M@2x.png" alt=""></span>
        </a>
      </div>
      <div v-if="csOrAdmin || bizOrAdminOrBizAdmin || deviceOrAdminOrBizAdmin" class="menu-6 menu" :class="menuInfo.mainTitle === 'Device' ? 'menu-select' : ''">
        <a @click="openSubMenu('Device')" class="menu-tlt">
          <span class="menu-img center-left"><img :src="menuInfo.mainTitle === 'Device' ? '/static/img/ico-menu-6-blue@2x.png' : '/static/img/ico-menu-6@2x.png'" alt=""></span>
          <span class="menu-txt center-left">재고관리</span>
          <span class="menu-img center-right"><img src="/static/img/ico-arrow-line-M@2x.png" alt=""></span>
        </a>
        <ul v-if="fold" class="menu-sub">
          <li v-if="csOrAdminOrBizAdmin"><a @click="goMenu('Device')" :class="menuInfo.subTitle === 'Device' ? 'menu-select-sub' : ''">
            <span class="menu-img center-left"><img :src="menuInfo.subTitle === 'Device' ? '/static/img/ico-menu-bullet-white@2x.png' : '/static/img/ico-menu-bullet-blue@2x.png'" alt=""></span>
            <span class="menu-txt center-left">AI 냉장고 관리</span>
          </a></li>
          <li v-if="csOrAdminOrBizAdmin"><a @click="goMenu('Product')" :class="menuInfo.subTitle === 'Product' ? 'menu-select-sub' : ''">
            <span class="menu-img center-left"><img :src="menuInfo.subTitle === 'Product' ? '/static/img/ico-menu-bullet-white@2x.png' : '/static/img/ico-menu-bullet-blue@2x.png'" alt=""></span>
            <span class="menu-txt center-left">상품 관리</span>
          </a></li>
          <li v-if="csOrAdmin || bizOrAdminOrBizAdmin || deviceOrAdminOrBizAdmin"><a @click="goMenu('Order')" :class="menuInfo.subTitle === 'Order' ? 'menu-select-sub' : ''">
            <span class="menu-img center-left"><img :src="menuInfo.subTitle === 'Order' ? '/static/img/ico-menu-bullet-white@2x.png' : '/static/img/ico-menu-bullet-blue@2x.png'" alt=""></span>
            <span class="menu-txt center-left">발주 관리</span>
          </a></li>
          <li v-if="csOrAdmin || bizOrAdminOrBizAdmin || deviceOrAdminOrBizAdmin"><a @click="goMenu('Stock')" :class="menuInfo.subTitle === 'Stock' ? 'menu-select-sub' : ''">
            <span class="menu-img center-left"><img :src="menuInfo.subTitle === 'Stock' ? '/static/img/ico-menu-bullet-white@2x.png' : '/static/img/ico-menu-bullet-blue@2x.png'" alt=""></span>
            <span class="menu-txt center-left">재고 관리</span>
          </a></li>
        </ul>
      </div>
      <div v-if="csOrAdmin" class="menu-2 menu"  :class="menuInfo.mainTitle === 'PurchaseHistory' ? 'menu-select' : ''">
        <a @click="goMenu('PurchaseHistory')" class="menu-tlt">
          <span class="menu-img center-left"><img :src="menuInfo.mainTitle === 'PurchaseHistory' ? '/static/img/ico-menu-2-blue@2x.png' : '/static/img/ico-menu-2@2x.png'" alt=""></span>
          <span class="menu-txt center-left">판매 현황</span>
          <span class="menu-img center-right"><img src="/static/img/ico-arrow-line-M@2x.png" alt=""></span>
        </a>
      </div>
      <!--
      <div v-if="csOrAdmin" class="menu-2 menu"  :class="menuInfo.mainTitle === 'PayHistory' ? 'menu-select' : ''">
        <a @click="goMenu('PayHistory')" class="menu-tlt">
          <span class="menu-img center-left"><img :src="menuInfo.mainTitle === 'PayHistory' ? '/static/img/ico-menu-2-blue@2x.png' : '/static/img/ico-menu-2@2x.png'" alt=""></span>
          <span class="menu-txt center-left">결제 내역</span>
          <span class="menu-img center-right"><img src="/static/img/ico-arrow-line-M@2x.png" alt=""></span>
        </a>
      </div>
      -->
      <!--
      <div v-if="deviceOrAdminOrBizAdmin" class="menu-8 menu" :class="menuInfo.mainTitle === 'DeviceSale' ? 'menu-select' : ''">
        <a @click="goMenu('DeviceSale')" class="menu-tlt">
          <span class="menu-img center-left"><img :src="menuInfo.mainTitle === 'DeviceSale' ? '/static/img/ico-menu-8-blue@2x.png' : '/static/img/ico-menu-8@2x.png'" alt=""></span>
          <span class="menu-txt center-left">메인 가맹점</span>
          <span class="menu-img center-right"><img src="/static/img/ico-arrow-line-M@2x.png" alt=""></span>
        </a>
      </div>
      -->
      <div v-if="csOrAdmin || bizOrAdminOrBizAdmin" class="menu-4 menu" :class="menuInfo.mainTitle === 'Sale' ? 'menu-select' : ''">
        <a @click="goMenu('Sale')" class="menu-tlt">
          <span class="menu-img center-left"><img :src="menuInfo.mainTitle === 'Sale' ? '/static/img/ico-menu-4-blue@2x.png' : '/static/img/ico-menu-4@2x.png'" alt=""></span>
          <span class="menu-txt center-left">매출 분석 관리</span>
          <span class="menu-img center-right"><img src="/static/img/ico-arrow-line-M@2x.png" alt=""></span>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-console */
/* eslint-disable no-alert */
/* eslint-disable no-plusplus */
/* eslint-disable no-await-in-loop */
/* eslint-disable no-continue */

import Configuration from '@/js/Configuration';
import UpdateModal from '@/components/account/UpdateModal';

export default {
  props: [
    'menuInfo',
    'isMain',
    'playAlarmError',
  ],
  components: {
    UpdateModal,
  },
  data: () => ({
    uID: null,
    userID: null,
    role: null,
    scope: null,
    modal: false,
    user: {
      uID: null,
      userID: null,
      name: null,
      role: null,
      passwd: null,
      manager: null,
      operator: null,
      monitor: null,
    },
    fold: false,
  }),
  computed: {
    csOrAdmin() {
      return (this.scope === 1 || this.scope === 2 || this.role === 1) && this.role !== 4;
    },
    csOrAdminOrMonitor() {
      return (this.scope === 1 || this.scope === 2 || this.role === 1) || (this.scope === 2 && this.role === 4);
    },
    csOrAdminOrBizAdmin() {
      return (this.scope === 1 || this.scope === 2 || this.role === 1 || this.role === 5) && this.role !== 4;
    },
    bizOrAdminOrBizAdmin() {
      return (this.scope === 1 || this.scope === 3 || this.role === 1 || this.role === 5);
    },
    deviceOrAdminOrBizAdmin() {
      return (this.scope === 1 || this.scope === 4 || this.role === 1 || this.role === 5);
    },
    managerOrAdminOrBizAdmin() {
      return (this.role === 1 || this.role === 2 || this.role === 5);
    },
  },
  created() {
    if (this.$cookie.get('accessToken')) {
      const token = this.$jwtDecode(this.$cookie.get('accessToken'));
      this.userID = token.userID;
      this.uID = token.uID;
      this.scope = token.scope;
      this.role = token.role;
    }
    if (!this.isMain) {
      if (this.menuInfo.mainTitle === 'Device' || this.menuInfo.mainTitle === 'Product' || this.menuInfo.mainTitle === 'Order' || this.menuInfo.mainTitle === 'Stock') {
        this.fold = true;
      }
    }
  },
  methods: {
    goMenu(menuName) {
      // this.$router.push({ name: menuName }).catch(() => {});
      const routeData = this.$router
        .resolve({
          name: menuName,
        });
      window.open(routeData.href, '_self');
    },
    openSubMenu() {
      this.fold = true;
      this.goMenu('Device');
    },
    async logout() {
      try {
        const res = await this.$http.put(
          `${Configuration.value(
            'CPAYMENT_ADDRESS',
          )}/api/v1/cpayment/user/logout/${this.uID}`,
          {
            userID: this.userID,
          },
          {
            headers: {
              Authorization: `Bearer ${this.$cookie.get('accessToken')}`,
            },
          },
        );
        if (res.status !== 200) {
          throw new Error(`Response status is "${res.status}"`);
        }
        if (res.data.resultCode !== '0000') {
          throw new Error(`ResultCode is "${res.data.resultCode}"`);
        }
      } catch (e) {
        alert('로그아웃에 실패하였습니다.');
        console.error(e);
      }

      //
      this.$deleteCookie();
      this.$router.push({ name: 'Login' });
    },
    async updateUser() {
      try {
        const role = this.$jwtDecode(this.$cookie.get('accessToken')).role;
        if (role === 0 || role === 1) return;

        const getURL = `${Configuration.value(
          'CACCOUNT_ADDRESS',
        )}/api/v1/caccount/user/${this.uID}`;

        const result = await this.$http.get(getURL, {
          headers: {
            Authorization: `Bearer ${this.$cookie.get('accessToken')}`,
          },
        });
        if (result.status !== 200) {
          throw new Error(`Response status is "${result.status}"`);
        }
        if (result.data.resultCode !== '0000') {
          throw new Error(`ResultCode is "${result.data.resultCode}"`);
        }

        this.user.uID = result.data.user.uID;
        this.user.userID = result.data.user.userID;
        this.user.name = result.data.user.name;
        this.user.role = result.data.user.role;
        this.user.email = result.data.user.email;
        this.user.mobile = result.data.user.mobile;
        this.user.manager = result.data.user.manager;
        this.user.operator = result.data.user.operator;
        this.user.monitor = result.data.user.monitor;
        this.modal = true;
      } catch (e) {
        console.error(e);
      }
    },
    closeModal() {
      this.modal = false;
    },
    reloadData() {
      this.modal = false;
    },
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/include/Toolbar.vue